import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=c479d6dc&"
import script from "./Popover.vue?vue&type=script&lang=ts&"
export * from "./Popover.vue?vue&type=script&lang=ts&"
import style0 from "./Popover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports